/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Activity_MatchedInputs */

const en_landing_preview_activity_matched = /** @type {(inputs: Landing_Preview_Activity_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`matched 12 clients to Brent note`)
};

/**
* | output |
* | --- |
* | "matched 12 clients to Brent note" |
*
* @param {Landing_Preview_Activity_MatchedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_activity_matched = /** @type {((inputs?: Landing_Preview_Activity_MatchedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Activity_MatchedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_activity_matched(inputs)
});